var $ = require('jquery'),
	$title = $('head title'),
	$link = $('head link[rel=canonical]'),
	$image = $('head meta.meta-image.og'),
	$w = $(window);

var socialNetworkAddress = (function(){

	var patterns = {
		facebook : 'https://www.facebook.com/sharer/sharer.php?p[url]={url}&p[title]={text}&caption={text}',
		twitter  : 'https://twitter.com/intent/tweet?url={url}&text={text}',
		email    : 'mailto:?body={url}&subject={text}',
		gplus    : 'https://plus.google.com/share?url={url}&title={text}',
		linkedin : 'https://www.linkedin.com/shareArticle?mini=true&url={url}&title={text}&summary={url}'
	};
		
	return function (network, text, url, image){
		
		if(patterns[network])
			return patterns[network]
				.replace('{url}', encodeURIComponent(url || '' + window.location))
				.replace('{text}', encodeURIComponent(('' + text).trim()))
				.replace('{url}', encodeURIComponent(url || '' + window.location))
				.replace('{image}', encodeURIComponent(image));
			
		console.log("No such network: "+network);
	}

}());
	
var social = module.exports = {
	
	clickHandler: function(e){
		
		var network = $(this).data('network'),
			text = $title.html()+'',
			url = $link.attr('href')+'',
			image = $image.attr('content')+'';
			
		url = new URL(url, window.location.href).href;
			
		$(this).attr('href', socialNetworkAddress(network, text, url, image));
		$(this).attr('target', network == 'email' ? '_self' : '_blank');
		
		//$w.trigger('gc.social', [network, $(this).closest('[data-region]').data('region')]);
		
		window.open(socialNetworkAddress(network, text, url, image), 'sharewindow', 'width=600,height=400,left=200,top=200');
	}
};	


//////////////////
// WEBPACK FOOTER
// ./themes/gc/js/social.js
// module id = 9
// module chunks = 0